// extracted by mini-css-extract-plugin
export default {"editor":"pip-option-editor_editor__jkLEm","formContainer":"pip-option-editor_formContainer__ZQP39"};